import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import errorIllustration from '../../assets/error.svg';
import messages from './messages';

const ErrorState = () => {
	const { formatMessage } = useIntl();
	const errorStateProps = {
		header: formatMessage(messages.header),
		description: formatMessage(messages.description),
		imageUrl: errorIllustration,
		maxImageWidth: 250,
		maxImageHeight: 250,
		imageWidth: 225,
		size: 'narrow',
	};

	return (
		<DataIdWrapper data-test-id="admin-pages-common.ui.error-state.fetch-error">
			{/* @ts-expect-error - TS2322 - Type '{ header: string; description: string; imageUrl: string; maxImageWidth: number; maxImageHeight: number; imageWidth: number; size: string; }' is not assignable to type 'EmptyStateProps'. */}
			<EmptyState {...errorStateProps} />
		</DataIdWrapper>
	);
};

export default ErrorState;

// to be wrapped only for components where test-id can't be added on some components
// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DataIdWrapper = styled.div<{
	children?: ReactNode;
	['data-test-id']: string;
}>({});
